import React, { Fragment } from "react";
import _ from "lodash";

export const formatAddress = address => {
  if (!address) {
    return null;
  }

  const { line1, line2, line3, line4, city, postalCode } = address;
  const line = _.join(_.without([line1, line2, line3, line4], null), " ");
  return line && city && postalCode ? `${line}, ${city}, ${postalCode}` : "";
};

export const formatAddressToSummary = (address, name) => {
  if (!address) {
    return "";
  }

  const { line1, line2, line3, line4, city, province, postalCode, country } = address;
  const line = _.join(_.without([line1, line2, line3, line4], null), " ");
  const location = _.join(_.without([city, province, postalCode], null), " ");

  return (
    <Fragment>
      <p className="panel-summary__value">{name}</p>
      <p className="panel-summary__value-small">{line}</p>
      <p className="panel-summary__value-small">{location}</p>
      <p className="panel-summary__value-small">{country}</p>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/helpers/addressHelpers.js